// @mui material components
import Grid from "@mui/material/Grid";

// mohtasham React components
import MDBox from "components/MDBox";

// mohtasham React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// mohtasham React contexts
import { useMaterialUIController, setDirection } from "context";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "examples/Footer";
import p1 from "assets/images/p1.jpeg";
import p2 from "assets/images/p2.jpeg";
import p3 from "assets/images/p3.jpg";
import p4 from "assets/images/p4.jpeg";
function Contactus() {
  const [controller, dispatch] = useMaterialUIController();
  const { sales, tasks } = reportsLineChartData;
  const [data, setData] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    setDirection(dispatch, "rtl");
  }, []);
  return (
    <DashboardLayout>
      {controller.authenticated && <DashboardNavbar title="درباره ما" />}

      <Grid
        container
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <a
          href="tel:09120914801"
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            borderRadius: 5,
            maxWidth: 250,
            margin: 10,
          }}
        >
          <div
            style={{
              width: 250,
              minWidth: 250,
              resize: "center",
              marginTop: 10,
              marginBottom: 5, 
            }}
          >
            <img
              src={p1}
              alt="گالری محتشم"
              style={{
                width: "100%",
                resize: "center",
                borderRadius: 5,
                boxShadow: "8px 8px #cccccc"
              }}
            />
          </div>
        </a>
        <a
          href="tel:09334311005"
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            borderRadius: 5,
            maxWidth: 250,
            margin: 10,
          }}
        >
          <div
            style={{
              width: 250,
              minWidth: 250,
              resize: "center",
              marginTop: 10,
              marginBottom: 5,
            }}
          >
            <img
              src={p2}
              alt="گالری محتشم"
              style={{
                width: "100%",
                resize: "center",
                borderRadius: 5,
                boxShadow: "8px 8px #cccccc"
              }}
            />
          </div>
        </a>
        <a
          href="tel:09113672815"
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            borderRadius: 5,
            maxWidth: 250,
            margin: 10,
          }}
        >
          <div
            style={{
              width: 250,
              minWidth: 250,
              resize: "center",
              marginTop: 10,
              marginBottom: 5,
            }}
          >
            <img
              src={p3}
              alt="گالری محتشم"
              style={{
                width: "100%",
                resize: "center",
                borderRadius: 5,
                boxShadow: "8px 8px #cccccc"
              }}
            />
          </div>
        </a>
        <a
          href="tel:09395658701"
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            borderRadius: 5,
            maxWidth: 250,
            margin: 10,
          }}
        >
          <div
            style={{
              width: 250,
              minWidth: 250,
              resize: "center",
              marginTop: 10,
              marginBottom: 5,
            }}
          >
            <img
              src={p4}
              alt="گالری محتشم"
              style={{
                width: "100%",
                resize: "center",
                borderRadius: 5,
                boxShadow: "8px 8px #cccccc"
              }}
            />
          </div>
        </a>
      </Grid>

      {controller.authenticated && <Footer />}
    </DashboardLayout>
  );
}

export default Contactus;
